export const CHANNEL_DEFS = [
  { id: 'meta', name: 'Meta (Facebook / Instagram)', desc: 'Соцсети' },
  { id: 'tiktok', name: 'TikTok Ads', desc: 'Короткие видео' },
  { id: 'google_search', name: 'Google Search', desc: 'Поиск' },
  { id: 'yandex_search', name: 'Яндекс Поиск', desc: 'Поиск' },
  { id: 'google_display', name: 'Google Display / YouTube', desc: 'Медийка' },
  { id: 'yandex_display', name: 'Яндекс РСЯ', desc: 'Медийка' },
];

export const DEFAULT_CHANNEL_DATA = {
  meta: { spend: 120000, leads: 45, revenue: 900000 },
  tiktok: { spend: 80000, leads: 60, revenue: 480000 },
  google_search: { spend: 100000, leads: 30, revenue: 750000 },
  yandex_search: { spend: 70000, leads: 25, revenue: 500000 },
  google_display: { spend: 50000, leads: 20, revenue: 200000 },
  yandex_display: { spend: 40000, leads: 18, revenue: 180000 },
};

export const DEFAULT_ACTIVE_CHANNELS = ['meta', 'google_search'];

export const clampNumber = (value, min, max = Number.MAX_SAFE_INTEGER) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return min;
  return Math.min(max, Math.max(min, parsed));
};

export const formatMoney = (value, locale = 'ru-RU') => {
  if (!Number.isFinite(value)) return '—';
  return `${Math.round(value).toLocaleString(locale)} ₸`;
};

export const formatCount = (value, locale = 'ru-RU') => {
  if (!Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString(locale);
};

export const calcChannelMetrics = (spend, leads, revenue) => {
  const s = clampNumber(spend, 0);
  const l = clampNumber(leads, 0);
  const r = clampNumber(revenue, 0);
  const cpl = l > 0 ? s / l : null;
  const romi = s > 0 ? ((r - s) / s) * 100 : null;
  return { spend: s, leads: l, revenue: r, cpl, romi };
};

export const calculateChannelComparison = (activeIds, data) => {
  const rows = activeIds
    .map((id) => {
      const raw = data[id] || { spend: 0, leads: 0, revenue: 0 };
      const metrics = calcChannelMetrics(raw.spend, raw.leads, raw.revenue);
      return { id, ...metrics };
    })
    .filter((row) => row.spend > 0 || row.leads > 0 || row.revenue > 0);

  const withCpl = rows.filter((r) => r.cpl != null && Number.isFinite(r.cpl));
  const withRomi = rows.filter((r) => r.romi != null && Number.isFinite(r.romi));

  const bestCpl = withCpl.length
    ? withCpl.reduce((best, row) => (row.cpl < best.cpl ? row : best), withCpl[0])
    : null;

  const bestRomi = withRomi.length
    ? withRomi.reduce((best, row) => (row.romi > best.romi ? row : best), withRomi[0])
    : null;

  const worstRomi = withRomi.length
    ? withRomi.reduce((worst, row) => (row.romi < worst.romi ? row : worst), withRomi[0])
    : null;

  return { rows, bestCpl, bestRomi, worstRomi };
};

const channelLabel = (id) => CHANNEL_DEFS.find((c) => c.id === id)?.name || id;

export const getChannelRecommendations = (comparison) => {
  const recs = [];
  const { rows, bestCpl, bestRomi, worstRomi } = comparison;

  if (rows.length === 0) {
    return [{ text: 'Заполните данные по выбранным каналам.' }];
  }

  if (rows.length === 1) {
    recs.push({ text: 'Добавьте ещё канал для сравнения.' });
    return recs;
  }

  if (bestCpl && bestRomi && bestCpl.id === bestRomi.id) {
    recs.push({
      text: `${channelLabel(bestCpl.id)} — лучший и по CPL, и по ROMI. Имеет смысл масштабировать этот канал первым.`,
    });
  } else {
    if (bestCpl) {
      recs.push({ text: `Низкий CPL у ${channelLabel(bestCpl.id)} — хорош для объёма лидов.` });
    }
    if (bestRomi) {
      recs.push({ text: `Высокий ROMI у ${channelLabel(bestRomi.id)} — сильнее окупается.` });
    }
  }

  if (worstRomi && worstRomi.romi < 0) {
    recs.push({
      text: `${channelLabel(worstRomi.id)}: ROMI отрицательный (${Math.round(worstRomi.romi)}%) — реклама не окупается. Остановите или пересмотрите креативы, оффер и качество лидов.`,
    });
  } else if (worstRomi && bestRomi && worstRomi.id !== bestRomi.id && worstRomi.romi < bestRomi.romi - 30) {
    recs.push({ text: `${channelLabel(worstRomi.id)} заметно слабее по ROMI — проверьте качество лидов и воронку.` });
  }

  rows
    .filter((row) => row.romi != null && row.romi < 0 && row.id !== worstRomi?.id)
    .forEach((row) => {
      recs.push({
        text: `${channelLabel(row.id)}: ROMI ${Math.round(row.romi)}% — канал в минусе. Сократите бюджет или оптимизируйте до выхода в плюс.`,
      });
    });

  return recs;
};

export const HOW_STEPS = [
  { num: '1', title: 'Каждый пункт имеет вес.', text: '«Да» = 100% балла, «Частично» = 50%, «Нет» = 0%. Итог — сумма взвешенных баллов.' },
  { num: '2', title: 'Пороги готовности:', text: 'до 50% — рано, 50–79% — доработать, 80%+ — можно запускать тест.' },
  { num: '3', title: 'Список «Сделать в первую очередь»', text: 'показывает пункты с ответом «Нет» и «Частично» по приоритету веса.' },
];
